import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import { authenticatedVimeoEmbedUrl } from "../vimeoEmbed";
import "./Exercise.scss";
import { ToastContainer, toast } from "react-toastify";

const Exercise = () => {
  const [exerciseData, setExerciseData] = useState({});
  const [exerciseVideoData, setExerciseVideoData] = useState();
  const [excerciseDate, setExcerciseDate] = useState("");
  const [excerciseActive, setExcerciseActive] = useState(false);
  const [activationError, setActivationError] = useState(false);
  const [activationPending, setActivationPending] = useState(false);
  const activationLock = useRef(false);

  const getExerciseData = async () => {
    const formData = new FormData();
    formData.append("user_id", localStorage.getItem("session_user_id"));

    const login_cookie = localStorage.getItem("session_user_login_cookie");
    const login_user_id = localStorage.getItem("session_user_id");
    const login_action_type = localStorage.getItem("session_user_type");

    const api = `${process.env.REACT_APP_API_BASE_URL}/?login_cookie=${login_cookie}&login_user_id=${login_user_id}&login_action_type=${login_action_type}&f=getActivatedExercise&status=1`;

    const resp = await axios.post(api, formData);
    const row = Array.isArray(resp.data) ? resp.data[0] : null;
    const status = row && String(row.status);
    if (!row || !["0", "1", "2"].includes(status) ||
        (row.student_id !== undefined && String(row.student_id) !== String(login_user_id)) ||
        (status === "1" && (String(row.student_id) !== String(login_user_id) ||
          !/^[1-9][0-9]*$/.test(String(row.activate_id)) || !Number.isSafeInteger(Number(row.activate_id))))) {
      throw new Error("Exercise status unavailable");
    }
    const result = { ...row, status, activate_id: row.activate_id === undefined ? null : Number(row.activate_id) };
    setExerciseData(result);
    setExcerciseActive(status === "1");
    if (status === "1") setExcerciseDate(row.start_date);
    return result;
  };

  const getExerciseVideo = async () => {
    const formData = new FormData();
    formData.append("user_id", localStorage.getItem("session_user_id"));
    const login_cookie = localStorage.getItem("session_user_login_cookie");
    const login_user_id = localStorage.getItem("session_user_id");
    const login_action_type = localStorage.getItem("session_user_type");
    const api = `${process.env.REACT_APP_API_BASE_URL}/?login_cookie=${login_cookie}&login_user_id=${login_user_id}&login_action_type=${login_action_type}&f=getExerciseVideoList&status=1`;

    return await axios.post(api, formData).then((resp) => {
      setExerciseVideoData(resp.data);
      return resp.data;
    });
  };

  const activeExercise = async () => {
    if (activationLock.current) return;
    activationLock.current = true;
    setActivationPending(true);
    setActivationError(false);
    try {
      const login_cookie = localStorage.getItem("session_user_login_cookie");
      const login_user_id = localStorage.getItem("session_user_id");
      const login_action_type = localStorage.getItem("session_user_type");
      const formData = new FormData();
      formData.append("user_id", localStorage.getItem("session_user_id"));
      formData.append("date", excerciseDate);
      formData.append("active_status", excerciseActive ? 1 : 0);
      const api = `${process.env.REACT_APP_API_BASE_URL}/?login_cookie=${login_cookie}&login_user_id=${login_user_id}&login_action_type=${login_action_type}&f=setActivateExercise&status=1`;
      const resp = await axios.post(api, formData);
      const expected = excerciseActive ? "1" : "0";
      if (resp.data?.status !== true || resp.data.active_status !== expected ||
          (expected === "1" && (!Number.isInteger(resp.data.activate_id) || resp.data.activate_id < 1))) {
        throw new Error("Exercise state unconfirmed");
      }
      const refreshed = await getExerciseData();
      if (refreshed.status !== expected ||
          (expected === "1" && refreshed.activate_id !== resp.data.activate_id)) {
        throw new Error("Exercise refresh contradicts activation");
      }
      const videos = await getExerciseVideo();
      if (expected === "1" && (videos?.status !== true || String(videos.active_status) !== "1" ||
          Number(videos.activate_id) !== resp.data.activate_id || !Array.isArray(videos.video) || videos.video.length === 0 ||
          !videos.video[0] || typeof videos.video[0] !== "object" ||
          !/^[1-9][0-9]*$/.test(String(videos.video[0].video_exercise_id)) ||
          !Number.isSafeInteger(Number(videos.video[0].video_exercise_id)) ||
          typeof videos.video[0].video_exercise_url !== "string" || !videos.video[0].video_exercise_url.trim())) {
        throw new Error("Exercise video refresh contradicts activation");
      }
      toast(localStorage.getItem("session_language") === "en" ? "Exercise status confirmed." : "Übungsstatus bestätigt.");
    } catch (_) {
      setActivationError(true);
    } finally {
      activationLock.current = false;
      setActivationPending(false);
    }
  };

  const exerciseCompletion = async (days, exercise_id, activated_id) => {
    if (activationLock.current) return;
    activationLock.current = true;
    setActivationPending(true);
    setActivationError(false);
    try {
      const login_cookie = localStorage.getItem("session_user_login_cookie");
      const login_user_id = localStorage.getItem("session_user_id");
      const login_action_type = localStorage.getItem("session_user_type");
      const formData = new FormData();
      formData.append("user_id", login_user_id);
      formData.append("days", days);
      formData.append("exercise_id", exercise_id);
      formData.append("activate_id", activated_id);
      const api = `${process.env.REACT_APP_API_BASE_URL}/?login_cookie=${login_cookie}&login_user_id=${login_user_id}&login_action_type=${login_action_type}&f=setExerciseCompletion&status=1`;
      const resp = await axios.post(api, formData);
      const result = resp.data;
      if (result?.status !== true || result.completed_status !== "1" ||
          result.student_id !== Number(login_user_id) || result.activate_id !== Number(activated_id) ||
          result.exercise_id !== Number(exercise_id) || result.count_id !== Number(days)) {
        throw new Error("Exercise completion unconfirmed");
      }
      const refreshed = await getExerciseData();
      const videos = await getExerciseVideo();
      if (refreshed.status !== "1" || refreshed.activate_id !== Number(activated_id) ||
          videos?.status !== true || String(videos.active_status) !== "1" || Number(videos.activate_id) !== Number(activated_id)) {
        throw new Error("Exercise completion refresh unconfirmed");
      }
      toast(localStorage.getItem("session_language") === "en" ? `Exercise completed for day ${days}.` : `Übung für Tag ${days} abgeschlossen.`);
    } catch (_) {
      setActivationError(true);
    } finally {
      activationLock.current = false;
      setActivationPending(false);
    }
  };

  useEffect(() => {
    getExerciseData().catch(() => setActivationError(true));
    getExerciseVideo();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const exerciseVideoSrc = authenticatedVimeoEmbedUrl(exerciseVideoData?.video?.[0]?.video_exercise_url, process.env.REACT_APP_API_BASE_URL, {
    loginUserId: localStorage.getItem("session_user_id"),
    loginCookie: localStorage.getItem("session_user_login_cookie"),
    loginActionType: localStorage.getItem("session_user_type"),
  });

  return (
    <div className="exercise_section">
      <div className="container-fluid">
        <ToastContainer />
        <div className="user_detail">
          <div className="exercise_title">
            <h2>EXERCISE</h2>
          </div>
        </div>
        <div className="exercise_listing">
          <div className="exercise_inner">
            <div className="exercise_date">
              <form className="row">
                <div className="col-12">
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id="gridCheck"
                      checked={excerciseActive}
                      disabled={activationPending}
                      onChange={(e) => {
                        setExcerciseActive(!excerciseActive);
                      }}
                    />
                    <label className="form-check-label" htmlFor="gridCheck">
                      Active Exercise Tool
                    </label>
                  </div>
                </div>
                <div className="form-input-column col-12">
                  <div className="form-input">
                    <input
                      type="date"
                      className="form-control"
                      id="inputdate"
                      value={excerciseDate}
                      disabled={activationPending}
                      onChange={(e) => {
                        setExcerciseDate(e.target.value);
                      }}
                    />
                  </div>
                </div>

                <div className="active-btn-column col-12">
                  <div className="active_btn">
                    <button
                      type="button"
                      disabled={activationPending}
                      className="btn btn_primary"
                      onClick={() =>
                        exerciseData.length < 9
                          ? toast("Please Select Start Date")
                          : activeExercise()
                      }
                    >
                      Active
                    </button>
                  </div>
                </div>
              </form>
            </div>

            {activationError && (
              <div role="alert" style={{backgroundColor: "#fff3cd", color: "#514000", border: "1px solid #a07900", padding: "16px"}}>
                {localStorage.getItem("session_language") === "en" ? "Exercise status could not be confirmed. Please reload the page." : "Der Übungsstatus konnte nicht bestätigt werden. Bitte lade die Seite erneut."}
              </div>
            )}

            {exerciseData.status === "1" && (
              <>
                <div className="exercise_card">
                  <div className="exercise_name">
                    {exerciseVideoData !== undefined && (
                      <h2>
                        <span className="exercise_type">Exercise Type :</span>{" "}
                        <span>
                          {exerciseVideoData?.video?.[0]?.video_exercise_title}
                        </span>
                      </h2>
                    )}
                  </div>
                  <div className="exercise_days">
                    <form className="row">
                      {exerciseVideoData !== undefined &&
                        Object.values(
                          exerciseVideoData?.video?.[0]?.video_date_list || {}
                        )?.map((item, index) => (
                          <div className="exercise_day_column col-xxl-2 col-xl-3 col-lg-4 col-md-6 col-sm-6 col-12">
                            <div className="exercise_day">
                              <h3>{item[0].days.split(" ")[2]}</h3>
                              <div className="form-check">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name={`flexRadioDefault${index}`}
                                  id={`flexRadioDefault${index}`}
                                  checked={item[0].status !== "0"}
                                  disabled={activationPending}
                                  onClick={() => {
                                    exerciseCompletion(
                                      index + 1,
                                      exerciseVideoData?.video?.[0]
                                        ?.video_exercise_id,
                                      exerciseVideoData?.activate_id
                                    );
                                  }}
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor={`flexRadioDefault${index}`}
                                >
                                  Day {index + 1}
                                </label>
                              </div>
                            </div>
                          </div>
                        ))}
                    </form>
                  </div>
                </div>

                <div className="exercise_video">
                  <div className="exercise_video_inner">
                    {exerciseVideoSrc ? (
                      <iframe
                        referrerPolicy="strict-origin-when-cross-origin"
                        src={exerciseVideoSrc}
                        frameBorder="0"
                        allow="autoplay; fullscreen; picture-in-picture"
                        allowFullScreen
                        style={{ width: "330px", height: "50vh" }}
                        webkitallowfullscreen=""
                      ></iframe>
                    ) : (
                      <p>NO VIDEO</p>
                    )}
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Exercise;
